import React from "react";
import CookiesContainer from "./CookiesContainer";

const Footer = () => {
  return (
    <>
      <CookiesContainer />
      <div className="footer__main">
        <p style={{}}></p>
        <p>
          {/* Merago Inc. Mountain View, California, USA. ©2025 All rights reserved
          -v 3.0.8 */}
          Copyright © 2026 | All Rights Reserved | A Service of Merago Inc. California, USA​
        </p>
       <a href="mailto:support@merago.com" style={{ marginRight: "25px",color:"#f7f7f7" }}>support@merago.com</a>
      </div>
    </>
  );
};

export default Footer;
